// eslint-disable-next-line @typescript-eslint/naming-convention
var PropertyMediaHandler = function( container ) {
    this.root = container;
    this.container = this.getContainer();
    this.targets = this.getTargets();
    this.btns = this.getBtns();
    this.active = 'none';

    document.addEventListener( 'twc:popup:open-property', this.update.bind( this ) );
    document.addEventListener( 'twc:popup:close-property', this.onPropertyClose.bind( this ) );

    this.update();
};

PropertyMediaHandler.prototype.onPropertyClose = function() {
    this.active = 'none';
};

PropertyMediaHandler.prototype.update = function() {
    this.container = this.getContainer();
    this.targets = this.getTargets();
    this.btns = this.getBtns();

    for ( var i = 0; i < this.btns.length; i++ ) {
        if ( this.btns[ i ].classList.contains( PropertyMediaHandler.classes.initialised ) ) {
            continue;
        }
        this.btns[ i ].addEventListener( 'click', this.onClick.bind( this ) );
        this.btns[ i ].classList.add( PropertyMediaHandler.classes.initialised );
    }

    for ( var targetIndex = 0; targetIndex < this.targets.length; targetIndex++ ) {
        if ( this.targets[ targetIndex ].classList.contains( PropertyMediaHandler.classes.active ) ) {
            this.active = this.targets[ targetIndex ].dataset.type;
        }
    }
};

PropertyMediaHandler.prototype.onClick = function( event ) {
    if ( !event.target || !event.target.dataset.mediaAction ) {
        return;
    }

    var targetType = event.target.dataset.mediaAction;

    if ( targetType === this.active ) {
        return;
    }

    if ( targetType === 'none' ) {
        this.container.classList.remove( 'twc__property--slider-hidden' );

        for ( var hideableIndex = 0; hideableIndex < this.targets.length; hideableIndex++ ) {
            this.targets[ hideableIndex ].classList.remove( PropertyMediaHandler.classes.active );
        }
    } else {
        this.container.classList.add( 'twc__property--slider-hidden' );

        for ( var i = 0; i < this.targets.length; i++ ) {
            if ( this.targets[ i ].dataset.type !== targetType ) {
                this.targets[ i ].classList.remove( PropertyMediaHandler.classes.active );
                continue;
            }

            var iframe = this.targets[ i ].querySelector( 'iframe' );

            if ( !iframe ) {
                throw new Error( 'no <iframe> element found' );
            }

            if ( !iframe.hasAttribute( 'src' ) ) {
                iframe.setAttribute( 'src', iframe.dataset.src );
            }

            this.targets[ i ].classList.add( PropertyMediaHandler.classes.active );
        }
    }

    for ( var j = 0; j < this.targets.length; j++ ) {
        var iframeToPause = this.targets[ j ].querySelector( 'iframe' );

        if ( !iframeToPause ) {
            throw new Error( 'no <iframe> element found' );
        }

        if ( iframeToPause.dataset.provider === 'youtube' && iframeToPause.hasAttribute( 'src' ) ) {
            iframeToPause.contentWindow.postMessage( PropertyMediaHandler.postMessages[ 'youtube:pause' ], '*' );
            continue;
        }

        if ( iframeToPause.dataset.provider === 'vimeo' && iframeToPause.hasAttribute( 'src' ) ) {
            iframeToPause.contentWindow.postMessage( PropertyMediaHandler.postMessages[ 'vimeo:pause' ], '*' );
            continue;
        }
    }

    this.active = targetType;
};

PropertyMediaHandler.prototype.remove = function() {
    this.root.removeEventListener( 'twc:popup:open-property', this.update.bind( this ) );
};

PropertyMediaHandler.prototype.getContainer = function() {
    return this.root.querySelector( '.twc__property--slider-primary' );
};

PropertyMediaHandler.prototype.getTargets = function() {
    return this.root.getElementsByClassName( PropertyMediaHandler.classes.target );
};

PropertyMediaHandler.prototype.getBtns = function() {
    return this.root.getElementsByClassName( PropertyMediaHandler.classes.btn );
};

PropertyMediaHandler.classes = {
    'btn': 'btn-media-launcher',
    'target': 'twc__property--media',
    'active': 'twc__property--media-active',
    'initialised': 'twc__property--media-initialised',
};

PropertyMediaHandler.postMessages = {
    'youtube:pause': '{"event":"command","func":"pauseVideo","args":""}',
    'vimeo:pause': '{"method":"pause"}',
};

export default function initPropertyMediaHandler( container ) {
    window.mediaHandler = new PropertyMediaHandler( container );
}

